import { savedOrderDetailsActionButtonsStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsActionButtons";
import { savedOrderDetailsProductListStyles } from "@insite/content-library/Widgets/SavedOrderDetails/SavedOrderDetailsProductList";
import { savedOrderListFilterStyles } from "@insite/content-library/Widgets/SavedOrderList/SavedOrderListFilter";
import { css } from "styled-components";

savedOrderDetailsProductListStyles.wrapper = {
    css: css`
        background-color: #ffffff;
        border: 1px solid #efefef;
        box-shadow: 0 3px 5px 0 rgba(0, 0, 0, 0.1);
        padding: 30px 20px;
        border-radius: 7px;
        > div[class^="GridWrapper"] {
            border-bottom: none;
        }
    `,
};
savedOrderDetailsActionButtonsStyles.buttonsHiddenContainer = {
    below: "lg",
    css: css`
        > button[data-test-selector="savedOrderDetails_addOrderToList"] {
            border: 2px solid #444444;
            background: #444444;
            color: #ffffff;
        }
    `,
};
savedOrderListFilterStyles.datesGridItem = {
    css: css`
        padding: 15px 30px;
    `,
    width: [12, 12, 6, 6, 4],
};
